// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__16F7P","icon":"style_icon__HAJ0K","title":"style_title__n-GBT","logo":"style_logo__1C6F5","logoContainer":"style_logoContainer__1qDcb"};